import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { duplicateBadgeStyles } from './IntakeDuplicateBadge.styles';
import { IntakeDuplicateBadgeTestIds } from './IntakeDuplicateBadge.testIds';
import { formatDuplicateBadgeText, formatDuplicateStatusText } from './IntakeDuplicateBadge.utils';

/**
 * Badge shown on an intake segment the backend flagged as a possible
 * duplicate of an already-filed document (`duplicateOf` in the staged plan).
 *
 * The status suffix mirrors the segment's file-toggle so the copy never
 * contradicts state: duplicates default to "skipped" and flip to
 * "filing anyway" when the user re-enables the toggle.
 */
const IntakeDuplicateBadge = ({ duplicateOf, isSelected, segId }) => (
  <Box data-testid={IntakeDuplicateBadgeTestIds.getBadgeId(segId)} sx={duplicateBadgeStyles}>
    <Typography variant="regular12">{formatDuplicateBadgeText(duplicateOf)}</Typography>
    <Typography variant="bold12">{formatDuplicateStatusText(isSelected)}</Typography>
  </Box>
);

IntakeDuplicateBadge.propTypes = {
  duplicateOf: PropTypes.shape({
    jobId: PropTypes.string,
    documentId: PropTypes.string,
    filedDate: PropTypes.string,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  segId: PropTypes.string.isRequired,
};

export default memo(IntakeDuplicateBadge);
